"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var VoiceTeacher_exports = {};
__export(VoiceTeacher_exports, {
  default: () => VoiceTeacher_default
});
module.exports = __toCommonJS(VoiceTeacher_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.20703 6.10938C4.52995 6.60417 4.0026 7.17057 3.625 7.80859C3.26042 8.44661 3.07812 9.1237 3.07812 9.83984C3.07812 10.3346 3.16927 10.8164 3.35156 11.2852C3.54688 11.7539 3.82031 12.1966 4.17188 12.6133C4.22396 12.6654 4.25651 12.7305 4.26953 12.8086C4.29557 12.8867 4.30208 12.9583 4.28906 13.0234L3.70312 15.8945L6.16406 14.4102C6.22917 14.3711 6.30078 14.3516 6.37891 14.3516C6.47005 14.3385 6.54818 14.3451 6.61328 14.3711C7.1862 14.6185 7.79818 14.8138 8.44922 14.957C9.10026 15.1003 9.78385 15.1719 10.5 15.1719C11.5417 15.1719 12.5182 15.0286 13.4297 14.7422C14.3411 14.4427 15.1289 14.0456 15.793 13.5508C16.4701 13.056 16.9909 12.4896 17.3555 11.8516C17.7331 11.2135 17.9219 10.543 17.9219 9.83984C17.9219 9.1237 17.7331 8.44661 17.3555 7.80859C16.9909 7.17057 16.4701 6.60417 15.793 6.10938C15.1289 5.61458 14.3411 5.22396 13.4297 4.9375C12.5182 4.65104 11.5417 4.50781 10.5 4.50781C9.45833 4.50781 8.48177 4.65104 7.57031 4.9375C6.65885 5.22396 5.87109 5.61458 5.20703 6.10938ZM4.60156 5.30859C4.99219 5.02214 5.40885 4.76823 5.85156 4.54688C6.29427 4.32552 6.76302 4.13672 7.25781 3.98047C7.76562 3.82422 8.29297 3.70703 8.83984 3.62891C9.3737 3.53776 9.92708 3.49219 10.5 3.49219C11.0729 3.49219 11.6263 3.53776 12.1602 3.62891C12.707 3.70703 13.2279 3.82422 13.7227 3.98047C14.2305 4.13672 14.7057 4.32552 15.1484 4.54688C15.5911 4.76823 16.0078 5.02214 16.3984 5.30859C17.1536 5.86849 17.7591 6.53906 18.2148 7.32031C18.6836 8.08854 18.918 8.92839 18.918 9.83984C18.918 10.7383 18.6836 11.5781 18.2148 12.3594C17.7591 13.1276 17.1536 13.7917 16.3984 14.3516C16.0078 14.638 15.5911 14.8919 15.1484 15.1133C14.7057 15.3346 14.2305 15.5234 13.7227 15.6797C13.2279 15.8359 12.707 15.9596 12.1602 16.0508C11.6263 16.1289 11.0729 16.168 10.5 16.168C9.77083 16.168 9.0612 16.1029 8.37109 15.9727C7.69401 15.8294 7.05599 15.6341 6.45703 15.3867L3.25391 17.3398C3.17578 17.3919 3.08464 17.418 2.98047 17.418C2.88932 17.418 2.79818 17.3854 2.70703 17.3203C2.62891 17.2682 2.57031 17.1966 2.53125 17.1055C2.49219 17.0143 2.48568 16.9167 2.51172 16.8125L3.25391 13.0625C2.88932 12.5938 2.60286 12.0859 2.39453 11.5391C2.1862 10.9922 2.08203 10.4258 2.08203 9.83984C2.08203 8.92839 2.3099 8.08854 2.76562 7.32031C3.23438 6.53906 3.84635 5.86849 4.60156 5.30859ZM7.58984 9.83984C7.58984 10.1784 7.46615 10.4714 7.21875 10.7188C6.97135 10.9661 6.67839 11.0898 6.33984 11.0898C5.98828 11.0898 5.6888 10.9661 5.44141 10.7188C5.20703 10.4714 5.08984 10.1784 5.08984 9.83984C5.08984 9.48828 5.20703 9.19531 5.44141 8.96094C5.6888 8.71354 5.98828 8.58984 6.33984 8.58984C6.67839 8.58984 6.97135 8.71354 7.21875 8.96094C7.46615 9.19531 7.58984 9.48828 7.58984 9.83984ZM11.75 9.83984C11.75 10.1784 11.6263 10.4714 11.3789 10.7188C11.1445 10.9661 10.8516 11.0898 10.5 11.0898C10.1484 11.0898 9.84896 10.9661 9.60156 10.7188C9.36719 10.4714 9.25 10.1784 9.25 9.83984C9.25 9.48828 9.36719 9.19531 9.60156 8.96094C9.84896 8.71354 10.1484 8.58984 10.5 8.58984C10.8516 8.58984 11.1445 8.71354 11.3789 8.96094C11.6263 9.19531 11.75 9.48828 11.75 9.83984ZM15.9102 9.83984C15.9102 10.1784 15.7865 10.4714 15.5391 10.7188C15.3047 10.9661 15.0117 11.0898 14.6602 11.0898C14.3216 11.0898 14.0286 10.9661 13.7812 10.7188C13.5339 10.4714 13.4102 10.1784 13.4102 9.83984C13.4102 9.48828 13.5339 9.19531 13.7812 8.96094C14.0286 8.71354 14.3216 8.58984 14.6602 8.58984C15.0117 8.58984 15.3047 8.71354 15.5391 8.96094C15.7865 9.19531 15.9102 9.48828 15.9102 9.83984Z",
      fill: "currentColor"
    }
  )
);
const SvgVoiceTeacher = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var VoiceTeacher_default = SvgVoiceTeacher;
